import { Routes } from "../api/routes";

export class ActivePageService {
  static getActivePageUrl(url) {
    if (url.indexOf('/user/') !== -1)
      return '/user-page';

    switch (url) {
      case '/':
        return '/';

      case '/monthly-overview':
        return '/monthly-overview';

      case '/monthly-overview/invoices':
        return '/monthly-overview/invoices';

      case '/monthly-overview/receipts':
        return '/monthly-overview/receipts';

      case '/monthly-overview/salaries':
        return '/monthly-overview/salaries';

      case '/admin-panel':
        return '/admin-panel';

      case '/forgot-password':
        return '/forgot-password';

      case '/reset-password':
        return '/reset-password';

      case '/files-upload':
        return '/files-upload';

      case '/missed':
        return '/missed';

      case '/project-management':
        return '/project-management';


      case Routes.emailTrackingReport:
        return Routes.emailTrackingReport;

      case Routes.authHistory:
        return Routes.authHistory;

      case Routes.generalDocuments:
        return Routes.generalDocuments;

      case Routes.invoiceRequest:
        return Routes.invoiceRequest;

      case Routes.expenseRequest:
        return Routes.expenseRequest;

      case Routes.serviceCall:
        return Routes.serviceCall;

      case Routes.myRequests:
        return Routes.myRequests;

      case Routes.accounts:
        return Routes.accounts;

      case Routes.monthlyReport:
        return Routes.monthlyReport;

      case Routes.salaries:
        return Routes.salaries;

      case Routes.salaryActions:
        return Routes.salaryActions;

      default:
        return null;
    }
  }
}
